import { render, staticRenderFns } from "./ProjectLegalModal_comp.vue?vue&type=template&id=4059f5ad&scoped=true&"
import script from "./ProjectLegalModal_comp.vue?vue&type=script&lang=js&"
export * from "./ProjectLegalModal_comp.vue?vue&type=script&lang=js&"
import style0 from "./ProjectLegalModal_comp.vue?vue&type=style&index=0&id=4059f5ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4059f5ad",
  null
  
)

export default component.exports